<template>
    <div>
        <div class="odmik-naslova">
            <p class="open-sans-20pt">
                Preverite porabo z mobilno aplikacijo Horizont
            </p>
        </div>
        <div class="odmik-vsebine-hramba">
            <p class="navadno-besedilo">
                Aplikacija Horizont omogoča varen prostor za shranjevanje vaših fotografij, video
                posnetkov, glasbenih vsebin ali drugih datotek. Upravljanje je pregledno in enostavno, vsebine
                pa lahko spremljate tudi na domačem televizorju ali osebnem računalniku.
            </p>
        </div>
        <div class="odmik-povezav">
            <a :href="horizontItunesPovezava" class="primarna-barva levi-odmik"
               target="_blank">
                <img src="/static/img/T2Aplikacije/Icon-awesome-apple.png"
                     class="odmik-ikone">
                <span class="odmik-ikona-tekst">
                    App Store
                </span>
            </a>
            <el-tooltip class="item primarna-barva" placement="bottom">
                <div slot="content">
                    Aplikacijo lahko namestite iz trgovine Huawei AppGallery na <br/>
                    mobilnih napravah Huawei.
                </div>
                <a class="primarna-barva levi-odmik">
                    <img src="/static/img/T2Aplikacije/Icon-simple-huawei.png"
                         class="odmik-ikone">
                    <span class="odmik-ikona-tekst">
                        Huawei AppGallery
                    </span>
                </a>
            </el-tooltip>
        </div>
    </div>
</template>
<script>
  import {Tooltip} from 'element-ui'
  import {povezave} from '../../../../../assets/js/Povezave/povezave'
  import ClientAgent from '../../../../../assets/js/clientAgent.js'
  export default {
    name: 'KomponentaPorabeHrambeAplikacije',
    data () {
      return {
        horizontItunesPovezava: '',
        horizontTrgovinaPlayPovezava: ''
      }
    },
    components: {
      [Tooltip.name]: Tooltip
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.horizontItunesPovezava = povezave.BASE_URL_HORIZONT_IOS_POVEZAVA
      this.horizontTrgovinaPlayPovezava = povezave.BASE_URL_HORIZONT_ANDROID_POVEZAVA
    }
  }
</script>
<style scoped src="../../../../../../static/css/Poraba/PorabaHramba/KomponentaPorabeHrambeAplikacije.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaHramba/KomponentaPorabeHrambeAplikacije.vue